module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA1.849d3229.jpg";